import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './style.css';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { messageState, modeState, pageviewState, sessionState } from '../../atoms';
import { canOrderProduct, prepareAuthorList, analyticsEvent, makeRequest, asaEvent } from '../../Utils';
import { useCartActions } from '../../hooks/useAddCart.js';


export default function Bestsellers() {
  const [lists, setLists] = useState([]);
  const [first, setFirst] = useState({});
  const setMessage = useSetRecoilState(messageState);
  const session = useRecoilValue(sessionState);
  const pageview = useRecoilValue(pageviewState);
  const mode = useRecoilValue(modeState);
  const { updateCart } = useCartActions();


  const getLists = async () => {
    let data = await makeRequest('bestsellers');
    setLists(data);
    let slug = data[0].slug;
    let request = await makeRequest(`list?slug=${slug}`);
    setFirst(request);
  }

  document.title = 'Bestsellers | Asterism Books'
  document.querySelector('meta[name="description"]').setAttribute('content', `Weekly lists of the bestsellers at Asterism Books`);

  useEffect(() => {
    getLists();
  }, []);

  const addToCart = (product) => {
    updateCart(product._id, product, 1, false);
    setMessage({ type: 'success', label: 'Added to Cart', text: `<strong>${product.title}</strong> has been added to your cart!`, img: product.cover['300'], temp: false, cart: true });
    analyticsEvent('addToCart', { product: product._id, location: 'productList', mode: mode });
    asaEvent({
      session: session.id,
      category: 'cart',
      action: 'addToCart',
      label: product._id,
      locationOne: 'bestsellersList',
      locationTwo: 'productCard',
      locationThree: 'button',
      testgroup: session.group,
      pagetype: pageview.pagetype,
      pageview: pageview.id,
      campaign: session.campaign,
      value: 1
    });
  }

  return (
    <div>
      {lists && lists.map((list, index) => {
        if (index === 0) {
          return (<div key={list._id} className='bestsellerCard'>
            <div className='bestsellerHeader roomAboveLarge roomBelowLarge'><h1 className='page-header'><Link to={`/list/${list.slug}`}>{list.title}</Link></h1></div>
            {first.products && first.products.map((product, index) => {
              return (
                <div key={product._id} className='bestsellerItem'>
                  <div className='bestsellerNo'><span className='bestsellerDigit'>{index + 1}</span></div>
                  <div className='bestsellerCover'>
                    <img src={product.cover['300']} alt={`Cover for ${product.title}`} />
                  </div>
                  <div className='bestsellerData'>
                    <div className='bestsellerDataContainer'>
                      <div className='bestsellerTitle'><Link className='' to={`/product/${product.slug}`}>{product.title}</Link></div>
                      <div className='bestsellerAuthor'>{prepareAuthorList(product)}</div>
                    </div>
                  </div>
                  <div className='bestsellerData'>
                    <div className='bestsellerDataContainer'>
                      <div className='bestsellerAuthor'><Link to={`/publisher/${product.publisherData.slug}`}>{product.publisherData.name}</Link></div>
                    </div>
                  </div>
                  <div className='bestsellerData'>
                    <div className='bestsellerDataContainer'>
                      <button className='bestsellerCart' disabled={!canOrderProduct(product, mode)} onClick={() => { addToCart(product) }}>Add to Cart <i className='fa-solid fa-plus'></i></button>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>)
        } else {
          return (<div key={list._id} className='asterismCard bestsellerCard'>
            <h4><Link to={`/list/${list.slug}`}>{list.title}</Link></h4>
          </div>)
        }
      }

      )}
    </div>
  )
}